import Menu, { MenuTypes } from '@zeptonow/zui/Menu';
import { SideBarPropsInterface, FilterRoutesInterface } from './types';
import { useCallback, useMemo } from 'react';
import { To, useLocation, useNavigate } from 'react-router-dom';
import getModuleRoutes from '../../routes/ModuleRoutes';
import useHasPermission from '../../hooks/useHasPermission';
import { AppStore } from '../../store/appStore';

const filterRoutes: FilterRoutesInterface = (routes, hasModulePermission) => {
  if (!routes || !routes.length) return undefined;
  return routes
    .filter(
      (route) =>
        route.sidebarVisibility !== false &&
        hasModulePermission({ moduleId: route.id })
    )
    .map((route) => ({
      ...route,
      children: filterRoutes(route.children, hasModulePermission),
    }));
};

export const SideBar = (props: SideBarPropsInterface) => {
  const { sideBarOpen } = props;
  const { hasModulePermission } = useHasPermission();

  const { pathname } = useLocation();

  const navigate = useNavigate();
  const isFormDirty = AppStore((state) => state.isFormDirty);
  const setShowUnsavedWorkConfirmationModal = AppStore(
    (state) => state.setShowUnsavedWorkConfirmationModal
  );
  const moduleRoutes = useMemo(() => {
    return getModuleRoutes(pathname);
  }, [pathname]);

  const filteredRoutes = filterRoutes(moduleRoutes, hasModulePermission) ?? [];

  const onMenuItemClick = useCallback(
    (event: React.MouseEvent<HTMLElement>, route: To) => {
      event.stopPropagation();
      if (!isFormDirty) {
        navigate(route);
      } else {
        setShowUnsavedWorkConfirmationModal(true);
      }
    },
    [isFormDirty]
  );

  return (
    <div className="my-4 bg-gray-900">
      <Menu
        items={filteredRoutes as Array<MenuTypes>}
        sidebarOpen={sideBarOpen}
        onClick={onMenuItemClick}
        currentPath={pathname}
      />
    </div>
  );
};

export default SideBar;
